import React, { Component } from 'react';
import styles from './index.css';
import {observer} from 'mobx-react';
import OnHoverDescription from "./onHoverDescription";
import PathPopupButtons from "./PathPopupButtons";
import PathPopupTabs from "./PathPopupTabs";
import PathBody from "./PathPopupBody";

@observer
export default class PathPopup extends Component {

    state={
        hoverItem:false, hoverId:0, hoverBody: true, drop:''
    };

    setDrop(drop){
        this.setState({drop});
    }

    setHoverElement(hoverItem,hoverId,hoveredDom){
        this.setState({hoverItem,hoverId,hoveredDom})
    }

    render(){
        return (
            <div className={styles.cover}>
                <div className={styles.body}>
                    <div className={styles.descriptionPathBody}>
                        <div>
                          <OnHoverDescription container={this.state.hoverItem} />
                        </div>
                        <PathBody {...this.state} setHoverElement={this.setHoverElement.bind(this)}/>
                    </div>
                    <div className={styles.bordur}/>
                    <PathPopupTabs setDrop={this.setDrop.bind(this)}
                                   onMouseOver={this.setHoverElement.bind(this)}
                                   setHoverElement={this.setHoverElement.bind(this)}
                                   {...this.state}/>
                    <PathPopupButtons />
                </div>
            </div>
        )
    }
}





// WEBPACK FOOTER //
// ./src/shared/components/PathPopup/index.js